import { Table as VenueContactsTable } from '@/components/venue_contact/table'

interface Props {
  venueId: string
}

export const EditContacts = ({ venueId }: Props) => {
  return (
    <>
      <VenueContactsTable pageSize={10} title="Contacts" venueId={venueId} createable fixedHeight updateable />
    </>
  )
}
